// Filter clients
export const filterOptions = [
  {
    id: "filterActiveClients",
    s: "clients",
    newOnly: 0,
    archived: 0,
  },
  {
    id: "filterArchivedClients",
    s: "",
    newOnly: 0,
    archived: 1,
  },
  {
    id: "filterExampleClients",
    s: "examples",
    newOnly: 0,
    archived: 0,
  },
  {
    id: "filterTemplateClients",
    s: "templates",
  },
];
